import { mergeDeep } from "@perxis-auto/shared";
const mergeConstructorItemProps = (item, defaultProps) => {
  return mergeDeep(defaultProps || {}, item.props || {});
};
export {
  mergeConstructorItemProps
};
